import { useMemo } from 'react';
import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { getLegResources } from '@lp/features/CaseLogistics/utils';
import { CaseResourceType } from '@/api/apis/case';
import { AviaLegTypes, GroundLegTypes } from '@/api/apis/route';
import { CompactResourcesList } from './CompactResourcesList';
import { FullResourcesList } from './FullResourcesList';

type LegDetailsResourcesProps = {
  leg: AviaLegTypes | GroundLegTypes;
  type?: 'full' | 'compact';
};

export const LegDetailsResources = ({ type = 'full', leg }: LegDetailsResourcesProps) => {
  const { ClinicalSpecialist: csList, Surgeon: sList, OCSConsole: devicesList } = useRouteResources();

  const deviceLegResources = useMemo(() => {
    return getLegResources(leg.resources, devicesList, CaseResourceType.OCSConsole);
  }, [leg, devicesList]);
  const csLegResources = useMemo(() => {
    return getLegResources(leg.resources, csList, CaseResourceType.ClinicalSpecialist);
  }, [leg, csList]);
  const sLegResources = useMemo(() => {
    return getLegResources(leg.resources, sList, CaseResourceType.Surgeon);
  }, [leg, sList]);

  if (type === 'compact') {
    return (
      <CompactResourcesList
        csList={csLegResources}
        deviceList={deviceLegResources}
        isScs={leg.hasScs}
        rsList={sLegResources}
      />
    );
  }

  return (
    <FullResourcesList
      csList={csLegResources}
      deviceList={deviceLegResources}
      isScs={leg.hasScs}
      rsList={sLegResources}
    />
  );
};
